<template>
	<div>
		<div v-if="!visualizar">
			<div class="no-print">
				<div v-if="!modal && cabecalho" class="no-print">
					<HeaderPage
						:title="titulo != '' 
														? titulo.toUpperCase() 
														: _traducao('global', 'despacho')"
						:sub-title="subTitulo != '' 
														? subTitulo.toUpperCase() 
														:_traducao('menuMonitoramento', 'menuMonitoraAeronaves')"
						:show-return="!visualizar"
						:show-print="form.id != 0"
						@voltar="voltaLista()"
						@print="clickPrint(0)"
					>
						<template #icon>
							<IconDespacho />
						</template>
						<template #actions>
							<ButtonCopy size="lg" v-if="form.id == 0" @click="copiarDespacho">
								{{ 
									titulo != ''
									? _traducao('global', 'copiar') + " " +
										_traducao('global', 'ultimo') + " " +
										titulo
									: _traducao('global', 'copiarDespacho') 
								}}
							</ButtonCopy>
						</template>
					</HeaderPage>
				</div>

				<AlertInfo> {{ _traducao('global', 'obrigatorio') }} </AlertInfo>

				<Section v-if="form.numero != ''">
					<HeaderForm>{{ _traducao('global', 'codigoSituacao') }}</HeaderForm>
					<Row>
						<Column xs="12" lg="12" form-group style="margin-top: 20px">
							<p style="margin-bottom: 0px; margin-top: 6px">
								{{ form.numero }} -
								<span v-if="form.status == 'A'">{{
									_traducao('global', 'aberta').toUpperCase()
								}}</span>
								<span v-if="form.status == 'E'">{{
									_traducao('global', 'encerrada').toUpperCase()
								}}</span>
							</p>
						</Column>
					</Row>
				</Section>

				<Section v-show="naoDefinirTipo == 0">
					<HeaderForm>
						{{ 
							titulo != ''
							? _traducao('cadAeronave','tipo') + " " +
								_traducao('global','de').toLowerCase() + " " +
								titulo
							: _traducao('global', 'tipoDespacho') 
						}}
					</HeaderForm>
					<Row>
						<Column
							xs="12"
							md="3"
							lg="3"
							v-if="
								_getPrivilegio(106) &&
								_prevencao_qualificada &&
								habilitaPreventiva == '1'
							"
						>
							<Button
								@click="clickSetaTipo('Q')"
								class="btn btn-block btn-default"
								:class="{'btn-success': form.tipo == 'Q'}"
							>
								<IconCheck v-show="form.tipo == 'Q'" />
								{{ _traducao('global', 'preventiva').toUpperCase() }}
							</Button>
						</Column>
						<Column xs="12" md="3" lg="3">
							<Button
								@click="clickSetaTipo('E')"
								class="btn btn-block btn-default"
								:class="{'btn-success': form.tipo == 'E'}"
							>
								<IconCheck v-show="form.tipo == 'E'" />
								{{ _traducao('global', 'emergencial') | upper }}
							</Button>
						</Column>
						<Column
							xs="12"
							md="3"
							lg="3"
							v-show="_idCliente != 18"
							v-if="habilitaCritica"
						>
							<Button
								@click="clickSetaTipo('C')"
								class="btn btn-block btn-default"
								:class="{'btn-success': form.tipo == 'C'}"
							>
								<IconCheck v-show="form.tipo == 'C'" />
								{{ labelCritica | upper }}
							</Button>
						</Column>
						<Column xs="12" md="3" lg="3">
							<Button
								@click="clickSetaTipo('P')"
								class="btn btn-block btn-default"
								:class="{'btn-success': form.tipo == 'P'}"
							>
								<IconCheck v-show="form.tipo == 'P'" />
								{{ _traducao('global', 'planejada') | upper }}
							</Button>
						</Column>
					</Row>
				</Section>

				<Section v-show="form.tipo == 'P'">
					<HeaderForm>{{ _traducao('global', 'ordemDeMissao') }}</HeaderForm>
					<Row>
						<Column xs="12" md="2" lg="2">
							<label>{{ _traducao('global', 'ordemDeMissao') }}:</label>
							<p>{{ form.ordem_codigo | na }}</p>
						</Column>
						<Column xs="12" md="2" lg="2">
							<label>{{ _traducao('global', 'data') }}:</label>
							<p>{{ form.ordem_data_inicio | dataTempo | na }}</p>
						</Column>
						<Column xs="12" md="2" lg="2">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<p>{{ form.ordem_descricao | na }}</p>
						</Column>
					</Row>
				</Section>

				<Section v-show="form.tipo == 'Q'">
					<HeaderForm>Prevenção Qualificada</HeaderForm>
					<Row>
						<Column xs="12" md="2" lg="2">
							<label>{{ _traducao('global', 'prevencaoDespacho') }}:</label>
							<br />
							<p>{{ form.prevencao_codigo | na }}</p>
						</Column>
						<Column xs="12" md="2" lg="2">
							<label>{{ _traducao('global', 'inicio') }}:</label>
							<br />
							<p>{{ form.prevencao_inicio | dataTempo | na }}</p>
						</Column>
						<Column xs="12" md="2" lg="2">
							<label>{{ _traducao('global', 'fim') }}:</label>
							<br />
							<p>{{ form.prevencao_fim | dataTempo | na }}</p>
						</Column>
						<Column xs="12" md="4" lg="4">
							<label>{{ _traducao('global', 'descricao') }}:</label>
							<br />
							<p>{{ form.prevencao_descricao | na }}</p>
						</Column>
					</Row>
				</Section>

				<div v-if="this.form.tipo != ''">
					<Section v-show="form.tipo == 'E' && naoDefinirTipo == 0">
						<HeaderForm>{{
							_traducao('global', 'solicitaUsoAeronave')
						}}</HeaderForm>
						<Row>
							<Column>
								<component
									@click="clickAddSolicitacao()"
									size="lg"
									:is="form.id_solicitacao == '' ? 'ButtonNew' : 'ButtonEdit'"
									>{{
										form.id_solicitacao == ''
											? _traducao('global', 'adicionar')
											: _traducao('global', 'alterar')
									}}
									{{ _traducao('global', 'solicitacao') }}</component
								>
							</Column>
						</Row>
						<Row
							style="margin-top: 15px"
							v-if="form.id_solicitacao != '' && form.tipo == 'E'"
						>
							<Column xs="2" md="2" lg="2">
								<strong>{{ _traducao('global', 'codigo') }}:</strong><br />
								{{ form.solicitacao_codigo }}
							</Column>
							<Column xs="10" md="10" lg="10">
								<strong>{{ _traducao('global', 'descricao') }}:</strong><br />
								{{ form.solicitacao_descricao }}
							</Column>
						</Row>
					</Section>

					<Section>
						<HeaderForm>
							{{
								titulo != ''
								? _traducao('global','dados') + " " +
									_traducao('global','do') + " " +
									titulo
								:_traducao('global', 'dadosDoDespacho')
							}}
						</HeaderForm>

						<Row>
							<Column
								xs="12"
								md="2"
								lg="2"
								form-group
								:class="{'has-error': erro.data_inicio != ''}"
							>
								<label>* {{ _traducao('global', 'dataAbertura') }}:</label>
								<flDateTime
									@v-model="(val) => (form.data_inicio = val)"
									:value="form.data_inicio"
									:lang="_getLangDp"
									:placeholder="_formatDate + ' HH:MM'"
									name="teste"
									:format="_formatDate + ' HH:mm'"
								/>
								<p class="help-block" v-if="erro.data_inicio">
									{{ erro.data_inicio }}
								</p>
							</Column>

							<Column
								xs="12"
								md="4"
								lg="4"
								form-group
								v-show="
									form.tipo != 'Q' &&
									(exibeRedsSamu == 'Exibir apenas 1 campo' ||
										exibeRedsSamu == 'Exibir os 2 campos')
								"
								:class="{'has-error': erro.numero_chamada != ''}"
							>
								<label>{{ this.numeroOcorrenciaSamu }}:</label>
								<input
									type="text"
									class="form-control input-sm"
									v-model="form.numero_chamada"
								/>
								<p class="help-block" v-if="erro.numero_chamada != ''">
									{{ erro.numero_chamada }}
								</p>
							</Column>

							<Column
								xs="12"
								md="4"
								lg="4"
								form-group
								v-show="
									form.tipo != 'Q' && exibeRedsSamu == 'Exibir os 2 campos'
								"
								:class="{'has-error': erro.numero_bo != ''}"
							>
								<label
									><span v-if="this.form.ocorrencia193Obrigatoria">*</span>
									{{ this.numeroOcorrencia193 }}:</label
								>
								<input
									type="text"
									class="form-control input-sm"
									maxlength="100"
									v-model="form.numero_bo"
								/>
								<p class="help-block" v-if="erro.numero_bo != ''">
									{{ erro.numero_bo }}
								</p>
							</Column>
						</Row>

						<Row>
							<Column
								md="6"
								lg="6"
								xs="12"
								form-group
								:class="{'has-error': erro.id_tipo_missao != null}"
							>
								<label
									>*
									{{
										nomeCampoTipoMissao !== ''
											? nomeCampoTipoMissao
											: _traducao('menuVoo', 'menuVtipoMissao')
									}}:</label
								>
								<form>
									<v-select
										v-model="form.id_tipo_missao"
										class="form-control input-sm"
										label="descricao"
										:options="tipos_missao"
										@search:blur="limpaCamposDepoisDeSelecionar()"
										@change="filtraCampos()"
									></v-select>
								</form>
								<p class="help-block" v-if="erro.id_tipo_missao != ''">
									{{ erro.id_tipo_missao }}
								</p>
							</Column>

							<Column
								md="6"
								lg="6"
								xs="12"
								v-if="habilitarCampoDescricao"
								form-group
							>
								<label>
									{{
										labelCampoDescricao !== ''
											? labelCampoDescricao
											: _traducao('global', 'descricaoDaOrdem')
									}}:</label
								>
								<form>
									<v-select
										v-model="form.descricao_tipo_missao"
										class="form-control input-sm"
										label="descricao"
										:options="descricaoMissaoAux"
									></v-select>
								</form>
							</Column>
						</Row>

						<div v-if="_idCliente != 41">
							<Row>
								<Column
									form-group
									:class="{'has-error': erro.classificacao != ''}"
								>
									<label>* {{ _traducao('global', 'classificacao') }}:</label>
									<v-select
										v-model="form.classificacao"
										class="form-control input-sm"
										:options="classificacaoAux"
										label="descricao"
										@search:blur="limpaCamposSubDepoisDeSelecionar()"
										@change="filtraSubclassificacao()"
									></v-select>
									<p class="help-block" v-if="erro.classificacao != ''">
										{{ erro.classificacao }}
									</p>
								</Column>

								<Column form-group>
									<label> {{ _traducao('global', 'subclassificacao') }}:</label>
									<v-select
										v-model="form.subclassificacao"
										class="form-control input-sm"
										:options="subclassificacoesAux"
										label="descricao"
									></v-select>
								</Column>
							</Row>
							<Divider />
						</div>

						<div class="form-group">
							<label v-show="form.orgao.length == 0"
								>* {{ centrodeCusto }}:</label
							>
							<div v-for="(itOrgao, idxOrgao) in form.orgao" :key="itOrgao.id">
								<Row>
									<Column
										xs="12"
										md="6"
										lg="6"
										form-group
										:class="{'has-error': itOrgao.erroOrgao != ''}"
									>
										<label
											>*
											{{
												_idCliente != 41
													? centrodeCusto
													: _traducao('global', 'clienteSolicitante')
											}}:</label
										>
										<a
											href="#"
											class="pull-right btn-remover-orgao"
											@click.prevent="form.orgao.splice(idxOrgao, 1)"
											type="button"
										>
											<i class="fa fa-trash fa-fw"></i
											>{{ _traducao('global', 'remover') }}
										</a>
										<form>
											<div
												:class="idxOrgao == 0 ? 'input-group' : ''"
												:style="{'z-index': 10 - idxOrgao}"
											>
												<v-select
													v-model="form.orgao[idxOrgao].orgao"
													class="form-control"
													:options="orgaos"
													label="sigla"
												></v-select>
												<span class="input-group-btn" v-if="idxOrgao == 0">
													<button
														class="btn btn-info btn-sm btn-md"
														@click="abreModalOap"
													>
														<i class="fa fa-plus fa-fw"></i>
													</button>
												</span>
											</div>
										</form>
										<p class="help-block" v-if="itOrgao.erroOrgao != ''">
											{{ itOrgao.erroOrgao }}
										</p>
									</Column>
								</Row>
							</div>
							<Row :class="{'has-error': erro.orgao}">
								<Column form-group>
									<ButtonNew size="lg" @click="clickAddOrgao">
										{{ centrodeCusto }}
									</ButtonNew>
									<p class="help-block" v-if="erro.orgao != ''">
										{{ erro.orgao }}
									</p>
								</Column>
							</Row>
						</div>
						<div>
							<Row>
								<Column
									form-group
									:class="{'has-error': erro.houve_contexto != ''}"
								>
									<label
										>* {{ _traducao('global', 'haContextoOperativo') }}</label
									>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.houve_contexto = '1'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '1'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.houve_contexto = '0'
												erro.houve_contexto = ''
											"
											:class="{'btn-info': form.houve_contexto == '0'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.houve_contexto != ''">
										{{ erro.houve_contexto }}
									</p>
								</Column>
							</Row>
							<Row v-if="form.houve_contexto == '1'">
								<Column
									xs="12"
									md="6"
									lg="6"
									form-group
									:class="{'has-error': erro.contexto_operativo != ''}"
								>
									<label
										>* {{ _traducao('global', 'contextoOperativo') }}</label
									>
									<form>
										<v-select
											v-model="form.contexto_operativo"
											class="form-control input-sm"
											:options="contextos"
											label="descricao"
										></v-select>
									</form>
									<p class="help-block" v-if="erro.contexto_operativo != ''">
										{{ erro.contexto_operativo }}
									</p>
								</Column>
							</Row>
						</div>

						<div v-if="isSigilosa == 1">
							<Row>
								<Column
									form-group
									:class="{'has-error': erro.missao_sigilosa != ''}"
								>
								<label
										>* {{ 'A missão é sigilosa?'}}</label
									>
									<br />
									<div class="btn-group print-button-group" role="group">
										<button
											type="button"
											@click="
												form.missao_sigilosa = '1'
												erro.missao_sigilosa = ''
											"
											:class="{'btn-info': form.missao_sigilosa == '1'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'sim') }}
										</button>
										<button
											type="button"
											@click="
												form.missao_sigilosa = '0'
												erro.missao_sigilosa = ''
												form.usuarios_missao_sigilosa = []
												form.usuarioSelecionado = null
											"
											:class="{'btn-info': form.missao_sigilosa == '0'}"
											class="btn btn-default btn-sm"
										>
											{{ _traducao('global', 'nao') }}
										</button>
									</div>
									<p class="help-block" v-if="erro.missao_sigilosa != ''">
										{{ erro.missao_sigilosa }}
									</p>
								</Column>
							</Row>
							<Row v-if="form.missao_sigilosa == '1'">
								<Column
									xs="12"
									md="6"
									lg="6"
									form-group
									:class="{'has-error': erro.usuarios_missao_sigilosa != ''}"
								>
									<label
										>* {{ ' Usuários que podem ter acesso a missão ' }}</label
									>
									<div class="input-group">
										<select
											v-model="form.usuarioSelecionado"
											class="input-sm form-control"
										>
											<option value="">
												{{ _traducao('global', 'escolha').toUpperCase() }}
											</option>
											<option v-for="usuario in usuarios" :key="usuario.id" :value="usuario.id">
												{{ usuario.nome }}
											</option>
										</select>
										<span class="input-group-btn">
											<button class="btn btn-sm btn-info" @click="ClickAddUserMissaoSigilosa()">
												ADD
												<i class="fa fa-arrow-right fa-fw"></i>
											</button>
										</span>
									</div>
									<p class="help-block" v-if="erro.usuarios_missao_sigilosa != ''">
										{{ erro.usuarios_missao_sigilosa }}
									</p>
								</Column>
							</Row>
							<Row>
								<Column
									xs="12"
									md="6"
									lg="6"
									form-group
								>
									<div style="margin-top: 5px">
										<span
											v-for="(user, index) in this.form.usuarios_missao_sigilosa"
											:key="index"
										>
											<span
												title="Clique para remover"
												class="label-click"
												@click="excluirUserMissaoSigilosa(index)"
											>
												{{ user.nome }}
												<i class="fa fa-times no-print"></i>
											</span>
										</span>
									</div>
								</Column>
							</Row>
						</div>

						<div>
							<Row>
								<Column form-group :class="{'has-error': erro.historico != ''}">
									<label>* {{ _traducao('global', 'historico') }}:</label>
									<textarea
										rows="4"
										class="form-control input-sm"
										v-model="form.historico"
									></textarea>
									<p class="help-block" v-if="erro.historico != ''">
										{{ erro.historico }}
									</p>
								</Column>
							</Row>
						</div>
						<div>
							<Row>
								<Column 
									xs="12"
									md="6"
									lg="6"
									form-group
								>
									<label>{{ 'Autorizado por' }}:</label>
									<i
												class="fa fa-fw fa-info-circle"
												v-tooltip.center="'Selecione o nome do responsável que autorizou a missão, ele será notificado automaticamente após o planejamento ser salvo'"
											>
											</i>
									<v-select
										v-model="form.autorizadoPor"
										class="form-control input-sm"
										:options="usuarios"
										label="nome"
									></v-select>
								</Column>
							</Row>
						</div>
					</Section>

					<Section>
						<HeaderForm>Aeronaves</HeaderForm>

						<div
							v-for="(item, index) in form.aeronave"
							:key="index"
							class="trecho-borda form-group"
							style="
								min-height: auto;
								margin-bottom: 20px;
								padding-bottom: 32px;
							"
						>
							<div class="row">
								<div
									:class="{'has-error': item.erro != ''}"
									class="col-md-4 col-xs-12 form-group"
									style="margin-bottom: 10px"
								>
									<label
										>* {{ _traducao('global', 'aeronave') }} {{ index + 1 }}:
									</label>
									<span class="pull-right" v-show="index > 0">
										<a
											href="#"
											:disabled="id_aeronave == item.id_aeronave"
											style="color: red"
											@click.prevent="form.aeronave.splice(index, 1)"
											type="button"
											><i class="fa fa-fw fa-trash"></i
											>{{ _traducao('global', 'remover').toUpperCase() }}</a
										>
									</span>
									<form>
										<select
											class="form-control input-sm"
											@change="
												() => {
													addTripulacao(index)
													changeBase(index, item.id_aeronave)
												}
											"
											:disabled="id_aeronave == item.id_aeronave"
											v-model="item.id_aeronave"
										>
											<option value="">
												{{ _traducao('global', 'escolha').toUpperCase() }}
											</option>
											<option
												v-for="item in aeronaves"
												v-show="_exibeAeroOrgao(item)"
												:value="item.id"
												:key="item.id"
											>
												{{ item.codinome }} - {{ item.prefixo }}
											</option>
										</select>
									</form>
									<p class="help-block" v-if="item.erro != ''">
										{{ item.erro }}
									</p>
								</div>

								<div
									class="col-md-2 col-xs-12 form-group"
									:class="{'has-error': item.erroBase != ''}"
								>
									<label>* {{ _traducao('global', 'base') }}:</label>
									<form>
										<select v-model="item.base" class="form-control input-sm">
											<option value="">
												{{ _traducao('global', 'escolha').toUpperCase() }}
											</option>
											<option
												v-for="item in bases"
												:key="item.descricao"
												:value="item.id"
											>
												{{ item.descricao }}
											</option>
										</select>
									</form>
									<p class="help-block" v-if="item.erroBase">
										{{ item.erroBase }}
									</p>
								</div>
							</div>

							<div
								class="row"
								v-for="(trip, idxTrip) in item.tripulacao"
								:key="trip.id"
							>
								<div v-if="item.id_aeronave != ''">
									<div class="col-md-1 col-xs-1"></div>

									<div
										class="col-md-4 col-xs-11 form-group"
										:class="{'has-error': trip.erroFuncao != ''}"
									>
										<label>{{ _traducao('global', 'funcao') }}:</label>
										<form>
											<select
												v-show="idxTrip == 0"
												class="form-control input-sm"
												v-model="item.voo_instrucao"
												@change="
													carregaUsuariosTripulacao(
														index,
														idxTrip,
														trip.funcao,
														true
													)
												"
											>
												<option
													v-for="funcao in funcaoPrincipal"
													:key="funcao.id"
													:value="funcao.voo_instrucao"
												>
													{{ funcao.nome }}
												</option>
											</select>
										</form>
										<form>
											<select
												v-show="idxTrip > 0"
												@change="
													carregaUsuariosTripulacao(
														index,
														idxTrip,
														trip.funcao,
														true
													)
												"
												class="form-control input-sm"
												v-model="trip.funcao"
											>
												<option
													v-for="funcao in listaDeFuncoes"
													:value="funcao.descricao"
													:key="funcao.id"
												>
													{{ funcao.nome }}
												</option>
											</select>
										</form>
										<p class="help-block" v-if="trip.erroFuncao">
											{{ trip.erroFuncao }}
										</p>
									</div>

									<div v-if="_isMobile" class="col-xs-1"></div>

									<div
										class="col-md-5 col-xs-11 form-group"
										:class="{'has-error': trip.erroTrigrama != ''}"
									>
										<label>{{ _traducao('global', 'nome') }}:</label>
										<small
											v-show="idxTrip == 0 && form.voo_instrucao == 0"
											class="text-info pull-right"
											><i class="fa fa-fw fa-info-circle"></i
											>{{ _traducao('global', 'obrigPilotoComando') }}</small
										>
										<small
											v-show="idxTrip == 0 && form.voo_instrucao == 1"
											class="text-info pull-right"
											><i class="fa fa-fw fa-info-circle"></i
											>{{ _traducao('global', 'obrigInstrutorVoo') }}</small
										>
										<template v-if="utilizaTrigrama">
											<form>
												<select
													v-if="_isMobile"
													v-model="trip.trigrama"
													@blur="
														setaNomeTripulanteTrigrama(
															index,
															idxTrip,
															trip.usuarios,
															trip.trigrama
														)
													"
													class="form-control input-sm"
												>
													<option
														v-for="(usr, idx) in trip.usuarios"
														:key="idx"
														:value="usr.trigrama"
													>
														{{ usr.trigrama }} - {{ usr.nome }}
														{{ usr.codigo_anac }}
													</option>
												</select>
											</form>
											<form>
												<flSelect
													:list="trip.usuarios"
													:value="
														trip.trigrama == ''
															? ''
															: trip.trigrama +
															  ' - ' +
															  trip.nome +
															  ' ' +
															  trip.codigo_anac
													"
													v-show="!trip.load"
													v-if="!_isMobile"
													@v-model="
														(input) =>
															setaNomeTripulanteTrigrama(
																index,
																idxTrip,
																trip.usuarios,
																input
															)
													"
													:return="'trigrama'"
													:label="'descricao'"
												/>
											</form>
										</template>
										<template v-else>
											<form>
												<select
													v-model="trip.id_usuario"
													v-show="!trip.load"
													@blur="
														setaNomeTripulante(
															index,
															idxTrip,
															trip.usuarios,
															trip.id_usuario
														)
													"
													class="form-control input-sm"
												>
													<option value="">
														{{ _traducao('global', 'escolha').toUpperCase() }}
													</option>
													<option
														v-for="(usr, idx) in trip.usuarios"
														:key="idx"
														:value="usr.id_usuario"
													>
														{{ usr.nome }}
													</option>
												</select>
											</form>
										</template>
										<flCarregando v-show="trip.load" />
										<p class="help-block" v-if="trip.erroTrigrama">
											{{ trip.erroTrigrama }}
										</p>
									</div>

									<div v-if="_isMobile" class="col-xs-1"></div>

									<div class="col-md-2 col-xs-11 form-group">
										<label v-show="!_isMobile" style="color: #f9f9f9"
											>teste:</label
										>
										<button
											v-show="idxTrip != 0"
											class="btn btn-sm btn-block btn-danger"
											type="button"
											@click="item.tripulacao.splice(idxTrip, 1)"
										>
											<i class="fa fa-trash fa-fw"></i>
											{{ _traducao('global', 'remover').toUpperCase() }}
										</button>
									</div>
								</div>
							</div>

							<div class="row" v-if="item.id_aeronave != ''">
								<div class="col-md-1 col-xs-1"></div>
								<div class="col-md-3 col-xs-11">
									<ButtonNew @click="clickAddTripulacao(index)" size="lg">
										{{ _traducao('global', 'adicionarTripulacao') }}
									</ButtonNew>
								</div>
							</div>
							<flCabecalhoForm
								cls="print-titulo-form-20"
								texto="Trechos"
								v-if="
									trechosAeronaves.filter(
										(a) => a.id_aeronave === item.id_aeronave
									).length > 0
								"
							/>
							<div
								v-for="(trecho, trechoIndex) in trechosAeronaves.filter(
									(a) => a.id_aeronave === item.id_aeronave
								)"
								:key="trechoIndex"
								style="margin-bottom: 12px"
							>
								<div>
									<h4
										class="col-xs-12 btn btn-sm btn-info"
										style="margin-bottom: 6px; pointer-events: none"
									>
										TRECHO {{ trechoIndex + 1 }}
									</h4>
								</div>
								<div class="row" style="margin-bottom: 32px">
									<div class="col-xs-6">
										<div class="text-center">ORIGEM</div>
										<div class="trecho-borda">
											<div class="row" style="min-height: 260px">
												<div class="col-xs-6 form-group">
													<label>Estado</label>
													<input
														class="form-control"
														:value="trecho.estado_origem"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>Cidade</label>
													<input
														class="form-control"
														:value="trecho.cidade_origem"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-12 form-group">
													<label>Aeroporto</label>
													<input
														class="form-control"
														:value="trecho.designativo_origem"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>Latitude</label>
													<input
														class="form-control"
														:value="trecho.latitude_origem"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>Longitude</label>
													<input
														class="form-control"
														:value="trecho.longitude_origem"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>{{ _traducao('global', 'decolagem') }}</label>
													<input
														class="form-control"
														:value="trecho._decolagem"
														disabled="disabled"
													/>
												</div>
											</div>
											<div class="row">
												<div class="col-xs-12">
													<CardDesignativo
														hide-infos
														:designativo="{
															sigla: trecho.designativo_origem
														}"
													/>
												</div>
											</div>
										</div>
									</div>
									<div class="col-xs-6">
										<div class="text-center">DESTINO</div>
										<div class="trecho-borda">
											<div class="row" style="min-height: 260px">
												<div class="col-xs-6 form-group">
													<label>Estado</label>
													<input
														class="form-control"
														:value="trecho.estado_destino"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>Cidade</label>
													<input
														class="form-control"
														:value="trecho.cidade_destino"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-12 form-group">
													<label>Aeroporto</label>
													<input
														class="form-control"
														:value="trecho.designativo_destino"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>Latitude</label>
													<input
														class="form-control"
														:value="trecho.latitude_destino"
														disabled="disabled"
													/>
												</div>
												<div class="col-xs-6 form-group">
													<label>Longitude</label>
													<input
														class="form-control"
														:value="trecho.longitude_destino"
														disabled="disabled"
													/>
												</div>
											</div>
											<div class="row">
												<div class="col-xs-12">
													<CardDesignativo
														hide-infos
														:designativo="{
															sigla: trecho.designativo_destino
														}"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-xs-12 col-md-3">
								<ButtonNew size="lg" @click="clickAddAero()">
									{{ _traducao('global', 'adicionarAeronave') }}
								</ButtonNew>
							</div>
						</div>
					</Section>

					<!-- BTN SALVAR -->
					<div>
						<hr
							style="margin-top: 2px; margin-bottom: 20px; margin-top: 20px"
						/>
						<div class="row" style="margin-bottom: 20px">
							<div class="col-lg-10 col-xs-9"></div>
							<div class="col-lg-2 col-xs-12">
								<ButtonConfirm
									size="lg"
									:disabled="desabilitarSalvar"
									@click="clickSalva"
									class="pull-right"
								>
									{{ _traducao('global', 'salvar') }}
								</ButtonConfirm>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- modal com a lista de ordem de missao -->
			<modal ref="modalOrdem">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalOrdem.modalHide()
						exibirEncerradas = false
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaOrdemDeMissao').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i
							>{{ _traducao('global', 'selecioneOrdemMissaoAbaixo') }}.

							<button
								class="btn btn-xs pull-right"
								:class="{
									'btn-default': !exibirEncerradas,
									'btn-success': exibirEncerradas
								}"
								@click="exibirEncerradas = !exibirEncerradas"
							>
								<i v-if="!exibirEncerradas" class="fa fa-fw fa-circle-o"></i>
								<i v-if="exibirEncerradas" class="fa fa-fw fa-check-circle"></i>
								{{ _traducao('global', 'exibirEncerradas') }}
							</button>
						</p>
					</div>
				</div>

				<div v-show="ordens.length > 0" class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaOrdem"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table
									class="table table-lista table-striped table-siga table-hover"
								>
									<thead>
										<tr>
											<th
												v-for="(coluna, idxColuna) in colunas"
												:key="idxColuna"
												style="width: 20%"
											>
												<ordem
													:coluna="coluna"
													:ordenacao="ordenacao"
													@click="ordenar"
												></ordem>
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaOrdem(item)"
											v-show="
												!exibirEncerradas
													? item.status.toUpperCase() == 'EM EXECUÇÃO'
													: item.status != ''
											"
											v-for="(item, idxT) in _ordens"
											:key="idxT"
										>
											<td>
												<span v-if="item.status.toUpperCase() == 'ABERTA'">
													<div class="text-info">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'aberta').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'EM EXECUÇÃO'">
													<div class="text-info">
														<!-- {{item.status.toUpperCase()}} -->
														{{
															_traducao('global', 'emExecucao').toUpperCase()
														}}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'ENCERRADA'">
													<div class="text-success">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'encerrada').toUpperCase() }}
													</div>
												</span>

												<span v-if="item.status.toUpperCase() == 'CANCELADA'">
													<div class="text-danger">
														<!-- {{item.status.toUpperCase()}} -->
														{{ _traducao('global', 'cancelada').toUpperCase() }}
													</div>
												</span>
											</td>
											<td>
												{{ item.codigo }}
												<br />
												<small>{{ item.descricao_ordem }}</small>
											</td>
											<td style="max-width: 400px; white-space: inherit">
												<span v-if="item.descricao_solicitacao == ''">{{
													_traducao('global', 'semSolicitacao').toUpperCase()
												}}</span>
												{{ item.codigo_solicitacao }}
												<br />
												<small>{{ item.descricao_solicitacao }}</small>
											</td>
											<td>
												{{ item.data_inicio | dataTempo }}
											</td>
											<td>
												{{ item.data_cadastro | dataTempo }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- modal com a lista de solicitações -->
			<modal ref="modalSolicitacao">
				<button
					type="button"
					class="close"
					@click="$refs.modalSolicitacao.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'selecioneUmaSolicitacao').toUpperCase() }}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i
							>{{ _traducao('global', 'selecioneSolicitacaoAbaixo') }}.
						</p>
					</div>
				</div>

				<div v-show="solicitacoes.length > 0" class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaSolicitacao"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table
									class="table table-lista table-striped table-siga table-hover"
								>
									<thead>
										<tr>
											<th>{{ _traducao('global', 'codigo') }}</th>
											<th>{{ _traducao('global', 'solicitacao') }}</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaSolicitacao(item)"
											v-for="(item, idxT) in _solicitacoes"
											:key="idxT"
										>
											<td>
												{{ item.codigo }}
											</td>
											<td style="max-width: 400px; white-space: inherit">
												{{ item.descricao_solicitacao }}
												<br />
												<br />
												<small
													><strong
														>{{
															_traducao('global', 'Por').toUpperCase()
														}}:</strong
													>
													{{ item.nome_usuario_inseriu }}</small
												>
											</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!-- <pre>{{_ordens}}</pre> -->
						</div>
					</div>
				</div>
			</modal>

			<!-- modal com a lista de prevenções -->
			<modal ref="modalPrevencao">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalPrevencao.modalHide()
						exibirEncerradas = false
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{
						_traducao(
							'global',
							'selecioneUmaPrevencaoQualificada'
						).toUpperCase()
					}}
				</h4>

				<hr style="margin-top: 6px" />

				<div class="row">
					<div class="col-xs-12">
						<p class="text-info">
							<i class="fa fa-fw fa-info-circle"></i
							>{{
								_traducao(
									'global',
									'selecioneAPrevencaoQualificadaAbaixo'
								).toUpperCase()
							}}
						</p>
					</div>
				</div>

				<div class="row form-group">
					<div class="col-xs-12">
						<i class="fa fa-search icone-busca" aria-hidden="true"></i>
						<input
							type="text"
							style="padding-left: 22px; margin-top: 7px"
							:placeholder="_traducao('global', 'buscar')"
							v-model.trim="buscaPrevencao"
							class="form-control"
						/>
					</div>
				</div>

				<div class="row">
					<div class="col-xs-12">
						<div
							ref="scrollDespacho"
							class="scroll"
							style="overflow-y: scroll"
							:style="{'max-height': this._height - 200 + 'px'}"
						>
							<div class="table-responsive">
								<table
									class="table table-lista table-striped table-siga table-hover"
								>
									<thead>
										<tr>
											<th style="width: 10%">
												{{ _traducao('global', 'status') }}
											</th>
											<th style="width: 20%">
												{{ _traducao('global', 'prevencaoQualificada') }}
											</th>
											<!-- <th>Solicitação</th> -->
											<th style="width: 10%">
												{{ _traducao('global', 'inicio') }}
											</th>
											<th style="width: 10%">
												{{ _traducao('global', 'fim') }}
											</th>
											<th style="width: 10%">
												{{ _traducao('global', 'cadastro') }}
											</th>
										</tr>
									</thead>
									<tbody>
										<tr
											style="cursor: pointer"
											class="table-hover-tr"
											@click="clickSetaPrevencao(item)"
											v-for="(item, idxT) in _prevencao"
											:key="idxT"
										>
											<td>
												<span v-if="item.status == 'A'">
													<div class="text-info">
														{{ _traducao('global', 'ativo').toUpperCase() }}
													</div>
												</span>
												<span v-if="item.status == 'C'">
													<div class="text-danger">
														{{ _traducao('global', 'cancelada').toUpperCase() }}
													</div>
												</span>
												<span v-if="item.status == 'F'">
													<div class="text-success">
														{{ _traducao('global', 'fechado').toUpperCase() }}
													</div>
												</span>
											</td>
											<td>
												{{ item.codigo_prevencao }}
												<br />
												<small>{{ item.descricao }}</small>
											</td>
											<td>
												{{ item.inicio_prevencao | dataTempo }}
											</td>
											<td>
												{{ item.fim_prevencao | dataTempo }}
											</td>
											<td>
												{{ item.data_cadastro | dataTempo }}
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</modal>

			<!-- MODAL SOLICITACAO OK -->
			<modal ref="modalOk">
				<button type="button" class="close" @click="$refs.modalOk.modalHide()">
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ 
						titulo != '' 
													? titulo.toUpperCase() 
													: _traducao('global', 'despacho')
				  }}
				</h4>

				<hr />

				<h2 class="text-center text-success">
					<i class="fa fa-check-circle"></i>
					{{
						titulo != '' 
													? titulo.toUpperCase() + " " +
														_traducao('global', 'salvo').toUpperCase()
													: _traducao('global', 'despachoSalvo').toUpperCase()
					}}
				</h2>

				<h2 class="text-center">
					{{ _traducao('global', 'numero').toUpperCase() }}: <br /><strong>{{
						form.numero
					}}</strong>
				</h2>

				<button
					class="btn btn-default"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						voltaLista()
					"
				>
					<i class="icon-left"></i>
					{{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
				</button>

				<button
					class="btn btn-default pull-right"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						clickPrint(300)
					"
				>
					<i class="icon-imprimir"></i> {{ _traducao('global', 'imprimir') }}
				</button>
			</modal>

			<div class="print">
				<flPrint ref="printCadastro" />
			</div>
		</div>

		<div v-if="visualizar">
			<!-- cabecalho -->
			<HeaderPage
				v-if="cabecalho"
				:title="titulo != '' 
														? titulo.toUpperCase() 
														: _traducao('global', 'despacho')"
				:sub-title="subTitulo != '' 
														? subTitulo.toUpperCase() 
														:_traducao('menuMonitoramento', 'menuMonitoraAeronaves')"
				:show-return="true"
				:show-print="true"
				@voltar="voltaLista()"
				@print="_print()"
				class="no-print"
			>
				<template #icon>
					<IconDespacho />
				</template>
				<template #actions>
					<ButtonCopy size="lg" v-if="form.id == 0" @click="copiarDespacho">
						{{ _traducao('global', 'copiarDespacho') }}
					</ButtonCopy>
				</template>
			</HeaderPage>

			<flPrint
				:cabecalho="false"
				:despacho-comercial="despachoComercial"
				ref="printVisualizar"
			/>
			<div v-if="despachoComercial">
				<flTrecho
					:form="form.aeronave"
					:disabled="true"
					:trecho-unico="true"
					:apenas-exibicao="true"
					:pouso-previsto="exibePouso"
					:visualizacao="true"
				/>
			</div>
		</div>
		<modal ref="orgaosApoiadosModal">
			<div :key="atualizaModal">
				<button
					type="button"
					class="close"
					@click="$refs.orgaosApoiadosModal.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>

				<flOrgaosApoiados :ehModal="true" />
			</div>
		</modal>
	</div>
</template>

<script>
import flPrint from './print.vue'
import trechoFactory from '@/factories/solicitacao/editando'
import trechoMixin from '@//modules/components/trecho/mixin'
import CardDesignativo from '../../fiscalizacao-rampa/publicacoes/card.vue'
import Ordem from './ordem.vue'
import Column from '../../../componentsv2/layout/Column.vue'
import _ from 'lodash'
export default {
	mixins: [trechoMixin],
	components: {
		flPrint,
		CardDesignativo,
		Ordem
	},

	props: {
		visualizar: {
			required: true,
			type: Boolean
		},

		cabecalho: {
			type: Boolean,
			required: false,
			default: true
		},

		aeronaves: {
			type: Array
		},

		contextos: {
			type: Array
		},

		classificacoes: {
			type: Array
		},

		subclassificacoes: {
			type: Array
		},

		rotaER: {
			type: Array,
			default: () => []
		},

		despachoComercial: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	computed: {
		editando() {
			return this.form.id == 0 ? false : true
		},

		_solicitacoes() {
			if (this.buscaSolicitacao == '') {
				return _.orderBy(this.solicitacoes, ['codigo'], ['desc'])
			}

			var list = this.solicitacoes.filter((cust) => {
				return (
					cust.descricao_solicitacao
						.toLowerCase()
						.indexOf(this.buscaSolicitacao.toLowerCase()) >= 0 ||
					cust.codigo
						.toLowerCase()
						.indexOf(this.buscaSolicitacao.toLowerCase()) >= 0 ||
					cust.nome_usuario_inseriu
						.toLowerCase()
						.indexOf(this.buscaSolicitacao.toLowerCase()) >= 0
				)
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		},

		_ordens() {
			var list = this.ordens
			if (this.buscaOrdem != '') {
				list = this.ordens.filter((cust) => {
					return (
						cust.status.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >=
							0 ||
						cust.codigo.toLowerCase().indexOf(this.buscaOrdem.toLowerCase()) >=
							0 ||
						cust.descricao_ordem
							.toLowerCase()
							.indexOf(this.buscaOrdem.toLowerCase()) >= 0
					)
				})
			}

			if (this.ordenacao.coluna == '') {
				return _.orderBy(list, ['data_inicio'], ['desc'])
			}
			const tipo = this.ordenacao.sentidoCrescente ? 'asc' : 'desc'
			return _.orderBy(list, [this.ordenacao.coluna], [tipo])
		},

		_prevencao() {
			let l = _.filter(this.prevencoes, (item) => {
				return item.status != 'C'
			})

			if (this.buscaPrevencao == '') {
				return _.orderBy(l, ['codigo'], ['desc'])
			}

			var self = this
			var list = l.filter(function (cust) {
				return (
					cust.status
						.toLowerCase()
						.indexOf(self.buscaPrevencao.toLowerCase()) >= 0 ||
					cust.codigo_prevencao
						.toLowerCase()
						.indexOf(self.buscaPrevencao.toLowerCase()) >= 0 ||
					cust.descricao
						.toLowerCase()
						.indexOf(self.buscaPrevencao.toLowerCase()) >= 0
				)
			})

			return _.orderBy(list, ['codigo'], ['desc'])
		}
	},

	data() {
		return {
			trechosAeronaves: [],
			habilitaPreventiva: '',
			nomeCampoTipoMissao: '',
			labelCampoDescricao: '',
			habilitarCampoDescricao: true,
			habilitaCritica: false,
			labelCritica: '',
			atualizaModal: 0,
			buscaSolicitacao: '',
			desabilitarSalvar: false,
			numeroOcorrenciaSamu: '',
			numeroOcorrencia193: '',
			exibeRedsSamu: '',
			centrodeCusto: '',
			descricoes: [],
			titulo: '',
			subTitulo: '',
			naoDefinirTipo: 0,
			ordenacao: {
				coluna: '',
				sentidoCrescente: true
			},
			colunas: [
				{
					nome: this._traducao('global', 'status'),
					campo: 'status'
				},
				{
					nome: this._traducao('global', 'ordemDeMissao'),
					campo: 'codigo'
				},
				{
					nome: this._traducao('global', 'solicitacao'),
					campo: 'codigo_solicitacao'
				},
				{
					nome: this._traducao('global', 'inicio'),
					campo: 'data_inicio',
					data_hora: true
				},
				{
					nome: this._traducao('global', 'cadastro'),
					campo: 'data_cadastro',
					data_hora: true
				}
			],

			//dados do mapa
			loadAero: true,
			exibirEncerradas: false,

			vincularLista: false,
			funcaoPrincipal: [],
			listaDeFuncoes: [],
			//aeronaves: [],
			modal: false,
			ordens: [],
			prevencoes: [],
			buscaOrdem: '',
			buscaPrevencao: '',
			bases: [],
			solicitacoes: [],
			classificacaoAux: [],
			subclassificacoesAux: [],
			descricaoMissaoAux: [],
			ver: false,
			//subclassificacoes: [],
			//contextos: [],

			id_aeronave: null,

			atualiza_ordem: false,

			usuarios: [],

			form: {
				id: 0,
				aeronave: [
					{
						id_aeronave: '',
						erro: '',
						novo: true,
						tripulacao: [],
						base: '',
						erroBase: '',
						voo_instrucao: '0',
						trecho: [trechoFactory.createTrecho()]
					}
				],

				prevencao_inicio: '',
				prevencao_fim: '',
				id_prevencao_qualificada: '',
				prevencao_codigo: '',
				prevencao_descricao: '',

				id_solicitacao: '',
				solicitacao_codigo: '',
				solicitacao_descricao: '',

				nome_usuario_inseriu: '',
				data_cadastro: '',
				ordem_data_inicio: '',
				ordem_codigo: '',
				ordem_descricao: '',
				id_ordem_missao: '',
				tipo: '',
				_tipo: '',
				id_usuario: '',
				base: '',
				numero: '',
				status: '',
				data_inicio: '',
				numero_bo: '',
				numero_chamada: '',
				ocorrencia193Obrigatoria: '',
				numero_atividade: '',
				classificacao: '',
				subclassificacao: '',
				houve_contexto: '',
				contexto_operativo: '',
				historico: '',
				relatorio_voo_trecho: [],
				orgao_apoiado: [],
				orgao: [],
				id_tipo_missao: null,
				descricao_tipo_missao: null,
				autorizadoPor: null,
				missao_sigilosa: '',
				usuarios_missao_sigilosa: [],
				usuarioSelecionado: null,
				isSigilosa: false,
			},
			erro: {
				id_aeronave: '',
				tipo: '',
				base: '',
				data_inicio: '',
				numero_bo: '',
				ocorrencia193Obrigatoria: '',
				numero_chamada: '',
				classificacao: '',
				subclassificacao: '',
				houve_contexto: '',
				contexto_operativo: '',
				historico: '',
				orgao_apoiado: '',
				orgao: '',
				id_tipo_missao: null,
				missao_sigilosa: '',
				usuarios_missao_sigilosa: '',
			},
			utilizaTrigrama: true,
			tipos_missao: [],
			todasMissoes: [],
			exibePouso: false
		}
	},

	created() {
		this.parametros()
		this.carregaFuncoesBordo()
		this.carregaDadosOap()
		this.carregaUsuarios()

		window.bus.$on('atualiza-dados-oap', () => {
			this.carregaDadosOap()
		})

		this.form.id_usuario = $sessao.getId()
		this._providerDescricaoDaMissao((lista) => {
			this.descricoes = lista
			this.filtraCampos()
		})

		this._providerBaseOperacional((lista) => (this.bases = lista))
		this.utilizaTrigrama = $cliente.get('utiliza_trigrama') === '1'
		this.carregaTiposMissao()
	},

	methods: {
		changeBase(index, id) {
			const aeronave = this.aeronaves.find((aero) => aero.id == id)
			if (aeronave) {
				this.form.aeronave[index].base = aeronave.id_base
			}
		},

		limpaCamposDepoisDeSelecionar() {
			this.form.classificacao = ''
			this.form.descricao_tipo_missao = ''
			this.form.subclassificacao = ''
		},

		limpaCamposSubDepoisDeSelecionar() {
			this.form.subclassificacao = ''
		},

		async carregaDadosOap() {
			this.orgaos = await this.getOrgaos()
		},

		filtraCampos() {
			this.filtraClassificacao()
			this.filtraDescricoes()
		},

		filtraClassificacao() {
			if (!this.vincularLista) {
				this.classificacaoAux = this.classificacoes
				return
			}
			if (!this.form.id_tipo_missao) return

			this.classificacaoAux = this.classificacoes.filter((item) => {
				return item.id_tipo_missao === this.form.id_tipo_missao.id
			})
		},

		filtraDescricoes() {
			if (!this.form.tipo_missao || !this.vincularLista) {
				this.descricaoMissaoAux = this.descricoes
			}
			if (!this.form.id_tipo_missao) return
			let resultado = this.descricoes.filter((item) => {
				return item.id_tipo_missao === this.form.id_tipo_missao.id
			})
			if (resultado && resultado.length > 0) {
				this.descricaoMissaoAux = resultado
			} else {
				this.descricaoMissaoAux = this.descricoes
			}
		},

		filtraSubclassificacao() {
			if (!this.vincularLista) {
				this.subclassificacoesAux = this.subclassificacoes
				return
			}
			if (!this.form.classificacao) return

			this.subclassificacoesAux = this.subclassificacoes.filter((item) => {
				return item.id_classificacao == this.form.classificacao.id
			})
		},

		async getOrgaos() {
			return new Promise((resolve) => {
				this._axios('Orgao_apoiado/get', 'get', {
					callback: (res) => {
						resolve(res.lista)
					}
				})
			})
		},

		abreModalOap() {
			this.$refs.orgaosApoiadosModal.modalShow(80)
			this.atualizaModal++
		},

		clickAddOrgao() {
			this.form.orgao.push({
				orgao: '',
				erroOrgao: '',
				erroTempoVoo: '',
				tempo_voo: 0,
				unidade: []
			})
		},

		carregaFuncoesBordo() {
			this._axios(`/Funcao_bordo/listar`, 'get', {
				callback: ({lista}) => {
					this.listaDeFuncoes = lista.map((item) => {
						item.descricao = item.descricao.toLowerCase()
						return item
					})

					this.funcaoPrincipal = lista
						.filter((item) =>
							['piloto em comando', 'piloto em instrução'].includes(
								item.descricao
							)
						)
						.map((fn, index) => {
							fn.descricao = fn.descricao.toLowerCase()
							fn.voo_instrucao = index
							return fn
						})
				}
			})
		},

		ordenar(coluna) {
			if (this.ordenacao.coluna == coluna) {
				this.ordenacao.sentidoCrescente = !this.ordenacao.sentidoCrescente
			} else {
				this.ordenacao.coluna = coluna
				this.ordenacao.sentidoCrescente = true
			}
		},

		novo() {
			//this.addTripulacao(0)
		},
		
		carregaUsuarios() {
			this._axios(`Usuario/get_ativo`, 'get', {
				callback: ({lista}) => {
					this.usuarios = lista
				}
			})
		},

		ClickAddUserMissaoSigilosa(user) {

			if(!user){
			   user = this.form.usuarioSelecionado
			}

			let usuarioSelecionado = this.usuarios.filter((usuario) => usuario.id == user)
			let existencia = false 

			if(this.form.usuarios_missao_sigilosa.length > 0) {
				for(let i=0; i < this.form.usuarios_missao_sigilosa.length; i++) {
					if(usuarioSelecionado.length > 0 && this.form.usuarios_missao_sigilosa[i].id == usuarioSelecionado[0].id){
						existencia = true
					}
				}
				if(existencia == false){
					this.form.usuarios_missao_sigilosa.push(usuarioSelecionado[0])
				}
			} else {
				this.form.usuarios_missao_sigilosa.push(usuarioSelecionado[0])
			}
		},

		excluirUserMissaoSigilosa(index) {
			this.form.usuarios_missao_sigilosa.splice(index, 1)
		},

		carregaUsuarios() {
			this._axios(`Usuario/get_ativo`, 'get', {
				callback: ({lista}) => {
					this.usuarios = lista
				}
			})
		},

		clickAddTripulacao(index) {
			let funcao = ''
			if (!this.form.aeronave[index].tripulacao.length) {
				funcao = 'piloto em comando'
				this.$nextTick(() => {
					this.carregaUsuariosTripulacao(index, 0, '', true)
				})
			}

			this.form.aeronave[index].tripulacao.push({
				trigrama: '',
				nome: '',
				erroTrigrama: '',
				funcao: funcao,
				erroFuncao: '',
				usuarios: [],
				load: false
			})
		},

		addTripulacao(index) {
			if (this.form.aeronave[index].novo) {
				this.form.aeronave[index].tripulacao.push({
					nome: '',
					trigrama: '',
					erroTrigrama: '',
					funcao: 'piloto em comando',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 0, 'piloto em comando', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					nome: '',
					erroTrigrama: '',
					funcao: 'copiloto',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 1, 'copiloto', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					erroTrigrama: '',
					funcao: 'operador aerotático',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 2, 'operador aerotático', true)

				this.form.aeronave[index].tripulacao.push({
					trigrama: '',
					nome: '',
					erroTrigrama: '',
					funcao: 'operador aerotático',
					erroFuncao: '',
					usuarios: [],
					load: false
				})

				this.carregaUsuariosTripulacao(index, 3, 'operador aerotático', true)

				this.form.aeronave[index].novo = false
			}
		},

		getFuncaoPorString(descricao) {
			return this.listaDeFuncoes.find((funcao) => funcao.descricao == descricao)
				.id
		},

		carregaUsuariosTripulacao(indexAero, indexTrip, funcao, zeraId) {
			if (indexTrip == 0) {
				this.form.aeronave[0].tripulacao[0].funcao =
					this.form.aeronave[indexAero].voo_instrucao == '0'
						? 'piloto em comando'
						: this.form.aeronave[indexAero].voo_instrucao == ''
						? 'piloto em comando'
						: 'piloto em instrução'

				funcao = this.form.aeronave[0].tripulacao[0].funcao
			}

			if (funcao == '') {
				funcao =
					this.form.aeronave[indexAero].voo_instrucao == '0'
						? 'piloto em comando'
						: this.form.aeronave[indexAero].voo_instrucao == ''
						? 'piloto em comando'
						: 'piloto em instrução'
			}

			if (funcao != '') {
				this.form.aeronave[indexAero].tripulacao[indexTrip].load = true
				this._axios(`/Usuario/get_by_funcao_bordo/${funcao}`, 'get', {
					callback: ({lista}) => {
						this.form.aeronave[indexAero].tripulacao[indexTrip].usuarios =
							lista.map((usuario) => {
								usuario.descricao =
									usuario.trigrama +
									' - ' +
									usuario.nome +
									' ' +
									usuario.codigo_anac
								usuario.id_usuario = usuario.id
								usuario.id = 0
								return usuario
							})
						this.form.aeronave[indexAero].tripulacao[indexTrip].load = false
						this.form.aeronave[indexAero].tripulacao[indexTrip].funcao = funcao
						if (zeraId) {
							this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario =
								''
						} else {
							this.setaNomeTripulante(
								indexAero,
								indexTrip,
								lista,
								this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario
							)
						}
						this.$forceUpdate()
					}
				})
			}
		},

		setaNomeTripulante(indexAero, indexTrip, usuarios, id_usuario) {
			for (var i in usuarios) {
				if (id_usuario == usuarios[i].id_usuario) {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome =
						usuarios[i].nome
					this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama =
						usuarios[i].trigrama
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario =
						usuarios[i].id_usuario
					this.form.aeronave[indexAero].tripulacao[indexTrip].codigo_anac =
						usuarios[i].codigo_anac
				}
			}
		},

		setaNomeTripulanteTrigrama(indexAero, indexTrip, usuarios, trigrama) {
			if (trigrama != '' || trigrama != null) {
				this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama =
					trigrama.toUpperCase()

				var idx = _.findIndex(usuarios, function (o) {
					return o.trigrama == trigrama.toUpperCase()
				})

				if (idx >= 0) {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome =
						usuarios[idx].nome
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario =
						usuarios[idx].id_usuario
					this.form.aeronave[indexAero].tripulacao[indexTrip].codigo_anac =
						usuarios[idx].codigo_anac
				} else {
					this.form.aeronave[indexAero].tripulacao[indexTrip].nome = ''
					this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
					this.form.aeronave[indexAero].tripulacao[indexTrip].trigrama = ''
				}
			} else {
				this.form.aeronave[indexAero].tripulacao[indexTrip].nome = ''
				this.form.aeronave[indexAero].tripulacao[indexTrip].id_usuario = ''
			}
		},

		novoModal(aeronave) {
			this.modal = true
			this.form.aeronave = []
			this.id_aeronave = aeronave.id
			this.form.aeronave.push({
				id_aeronave: aeronave.id,
				erro: '',
				novo: true,
				base: '',
				erroBase: '',
				tripulacao: []
			})

			this.addTripulacao(this.form.aeronave.length - 1)
		},

		editar(item, programacaoVoo = false) {
			if (programacaoVoo) {
				this.carregaProgramacao(item)
			} else {
				this.carrega(item)
			}
		},

		copiarDespacho() {
			const copia = this.carregaDespachos()
		},

		carregaDespachos() {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			this._httpGet('mg-siga/Despacho_emergencial/copiar', (retorno) => {
				window.bus.$emit('load-out')

				if (retorno._request && retorno._status) {
					this.form.id = 0
					this.form.aeronave = retorno.lista.aeronave.map((o) => {
						o.voo_instrucao = o.voo_instrucao
						o.erro = ''
						o.erroBase = ''
						o.tripulacao = o.tripulacao.map((trip) => {
							trip.erroTrigrama = ''
							trip.erroFuncao = ''
							trip.load = true
							trip.novo = false
							trip.usuarios = []
							return trip
						})

						return o
					})

					for (var j in this.form.aeronave) {
						for (var i in this.form.aeronave[j].tripulacao) {
							this.carregaUsuariosTripulacao(
								j,
								i,
								this.form.aeronave[j].tripulacao[i].funcao,
								false
							)
						}
					}

					this.form.inicio_prevencao =
						retorno.lista.prevencao_qualificada == null
							? ''
							: retorno.lista.prevencao_qualificada.inicio_prevencao
					this.form.fim_prevencao =
						retorno.lista.prevencao_qualificada == null
							? ''
							: retorno.lista.prevencao_qualificada.fim_prevencao
					this.form.codigo_prevencao =
						retorno.lista.prevencao_qualificada == null
							? ''
							: retorno.lista.prevencao_qualificada.codigo_prevencao
					this.form.descricao_prevencao =
						retorno.lista.prevencao_qualificada == null
							? ''
							: retorno.lista.prevencao_qualificada.descricao
					this.form.base = retorno.lista.base == null ? '' : retorno.lista.base
					this.form.data_inicio = this._SQLDateToDateTime(
						retorno.lista.data_inicio,
						$sessao.getDateFormat() + ' HH:MM'
					)
					this.form.numero_bo = retorno.lista.reds
					this.form.numero_chamada = retorno.lista.chamada
					this.form._tipo = retorno.lista._tipo
					this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
					this.form.data_cadastro = retorno.lista.data_cadastro
					this.form.numero_atividade = retorno.lista.atividade
					this.form.houve_contexto = retorno.lista.houve_contexto
					this.form.historico = retorno.lista.historico
					this.form.numero = retorno.lista.numero
					this.form.id_solicitacao =
						retorno.lista.id_solicitacao == null
							? ''
							: retorno.lista.id_solicitacao
					this.form.solicitacao_descricao =
						retorno.lista.solicitacao_descricao == null
							? ''
							: retorno.lista.solicitacao_descricao
					this.form.solicitacao_codigo =
						retorno.lista.solicitacao_codigo == null
							? ''
							: retorno.lista.solicitacao_codigo

					if (!_.isNil(retorno.lista.relatorio_voo_trecho)) {
						this.form.relatorio_voo_trecho = retorno.lista.relatorio_voo_trecho
					} else {
						this.form.relatorio_voo_trecho = []
					}

					this.form.prevencao_inicio = retorno.lista.prevencao_inicio
					this.form.prevencao_fim = retorno.lista.prevencao_inicio
					this.form.id_prevencao_qualificada =
						retorno.lista.id_prevencao_qualificada
					this.form.prevencao_codigo = retorno.lista.prevencao_codigo
					this.form.prevencao_descricao = retorno.lista.prevencao_descricao

					this.form.status = retorno.lista.status
					this.form.id_ordem_missao = retorno.lista.id_ordem_missao
					this.form.tipo = retorno.lista.tipo
					this.form.ordem_descricao = retorno.lista.ordem_descricao
					this.form.ordem_codigo = retorno.lista.ordem_codigo
					this.form.ordem_data_inicio = retorno.lista.ordem_data_inicio
					if (this._idCliente != 41) {
						this.form.classificacao = _.find(this.classificacao, (c) => {
							return c.id == retorno.lista.id_classificacao
						})
						this.form.subclassificacao = _.find(this.subclassificacoes, (o) => {
							return o.id == retorno.lista.id_subclassificacao
						})
					}
					// this.form.voo_instrucao = retorno.lista.voo_instrucao

					if (this.form.houve_contexto == 1) {
						this.form.contexto_operativo = _.find(this.contextos, (o) => {
							return o.id == retorno.lista.id_contexto_operativo
						})
					}
					// orgaos recebidos
					retorno.lista.orgao.forEach((orgao) => {
						const orgao_apoiado = {}
						const unidades = []
						const orgao_encontrado_por_id = this.orgaos.find(
							({id}) => id == orgao.id
						)

						orgao_apoiado.orgao = orgao_encontrado_por_id

						orgao_apoiado.unidade = unidades
						orgao_apoiado.erroOrgao = ''
						this.form.orgao = [orgao_apoiado]
					})

					// console.log("form antes carrega dados", this.form)

					// if (this.form.tipo == 'Q') {
					// 	this.carregaPrevencao()
					// }

					// if (this.visualizar) {
					// 	this.$refs.printVisualizar.carregaDados(this.form)
					// }
				}
			})
		},

		clickAddAero() {
			this.form.aeronave.push({
				id_aeronave: '',
				erro: '',
				tripulacao: [],
				base: '',
				erroBase: '',
				novo: true,
				voo_instrucao: '0'
			})
		},

		voltaLista() {
			//this.carregaDadosOap()
			this.$emit('volta-lista')
		},

		clickSalva() {
			if (this.validaForm()) {
				var aeros = Object.assign([], this.form.aeronave)
				if(this.isSigilosa == 1 && this.form.missao_sigilosa == '1'){
					this.ClickAddUserMissaoSigilosa($sessao.getId())
				}
				var data = {
					id: this.form.id,
					aeronave: aeros.map((item) => {
						var trips = []
						for (var i in item.tripulacao) {
							if(this.isSigilosa == 1 && this.form.missao_sigilosa == '1'){
								this.ClickAddUserMissaoSigilosa(item.tripulacao[i].id_usuario)
							}
							if (item.tripulacao[i].trigrama != '') {
								item.tripulacao[i].usuarios = []
								trips.push(item.tripulacao[i])
							} else if (
								!this.utilizaTrigrama &&
								item.tripulacao[i].id_usuario !== ''
							) {
								item.tripulacao[i].usuarios = []
								trips.push(item.tripulacao[i])
							}
						}
						item.tripulacao = trips
						return item
					}),
					orgao: this.form.orgao.map((item) => {
						var orgao = {
							id: item.orgao.id,
							unidade: []
						}
						return orgao
					}),
					id_usuario: $sessao.getId(),
					base: this.form.base,
					data_inicio: this._dateTimeToDateSQL(
						this.form.data_inicio,
						$sessao.getDateFormat() + ' HH:MM'
					),
					reds: this.form.numero_bo,
					chamada: this.form.numero_chamada,
					atividade: this.form.numero_atividade,
					id_classificacao: this.form.classificacao
						? this.form.classificacao.id
						: '',
					id_subclassificacao: this.form.subclassificacao
						? this.form.subclassificacao.id
						: '',
					houve_contexto: this.form.houve_contexto,
					id_contexto_operativo:
						this.form.houve_contexto == 1
							? this.form.contexto_operativo.id
							: '',
					historico: this.form.historico,
					id_ordem_missao: this.form.id_ordem_missao,
					id_prevencao_qualificada: this.form.id_prevencao_qualificada,
					tipo: this.form.tipo,
					ordem_descricao:
						typeof this.form.descricao_tipo_missao === 'string'
							? this.form.descricao_tipo_missao
							: this.form.descricao_tipo_missao?.descricao,
					ordem_codigo: this.form.ordem_codigo,
					ordem_data_inicio: this.form.ordem_data_inicio,
					atualiza_ordem: this.atualiza_ordem,
					id_solicitacao: this.form.id_solicitacao,
					solicitacao_codigo: this.form.solicitacao_codigo,
					solicitacao_descricao: this.form.solicitacao_descricao,

					prevencao_inicio: this.form.prevencao_inicio,
					prevencao_fim: this.form.prevencao_inicio,
					id_prevencao_qualificada: this.form.id_prevencao_qualificada,
					prevencao_codigo: this.form.prevencao_codigo,
					prevencao_descricao: this.form.prevencao_descricao,
					id_tipo_missao: this.form.id_tipo_missao.id,
					// voo_instrucao: this.form.voo_instrucao
					autorizado_por: this.form.autorizadoPor ? this.form.autorizadoPor.id : null,
					missao_sigilosa: this.form.missao_sigilosa ? this.form.missao_sigilosa : null,
					usuarios_missao_sigilosa: this.form.usuarios_missao_sigilosa ? this.form.usuarios_missao_sigilosa : null,
				}
				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})
				this._httpPost(
					'mg-siga/Despacho_emergencial/salvar',
					data,
					(response) => {
						bus.$emit('load-out')
						if (response._request && response._status) {
							this.desabilitarSalvar = true
							this.form.numero = response.lista.numero
							this.form.id = response.lista.id
							if (!this.modal) {
								this.$refs.modalOk.modalShow(60)
							}

							this.$emit('despacho-add', response.lista)
						}
					}
				)
			} else {
				bus.$emit('exibir-notificacao', {
					text: this._traducao('menuEscala', 'menuEvermelho'),
					type: 'danger'
				})
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			this.form.aeronave = this.form.aeronave.map((item, index) => {
				if (item.id_aeronave == '') {
					passou = false
					item.erro = obrigatorio
				} else {
					item.erro = ''

					for (var i in this.form.aeronave) {
						if (this.form.aeronave[i].id_aeronave == item.id && index != i) {
							item.erro = 'Esssa aeronave está duplicada.'
							passou = false
						}
					}
				}

				if (item.base == '') {
					passou = false
					item.erroBase = obrigatorio
				} else {
					item.erroBase = ''
				}

				if (item.tripulacao.length > 0) {
					if (this.utilizaTrigrama) {
						if (item.tripulacao[0].trigrama == '') {
							item.tripulacao[0].erroTrigrama = 'Obrigatório.'
							passou = false
						} else {
							item.tripulacao[0].erroTrigrama = ''
						}
					} else {
						if (item.tripulacao[0].id_usuario == '') {
							item.tripulacao[0].erroTrigrama = 'Obrigatório.'
							passou = false
						} else {
							item.tripulacao[0].erroTrigrama = ''
						}
					}
				}

				return item
			})

			if (this.form.ocorrencia193Obrigatoria) {
				if (this.form.numero_bo == '') {
					this.erro.numero_bo = obrigatorio
					passou = false
				} else {
					this.erro.numero_bo = ''
				}
			}

			if (this.form.data_inicio == '') {
				this.erro.data_inicio = obrigatorio
				passou = false
			} else {
				this.erro.data_inicio = ''
			}

			if (this.form.historico == '') {
				this.erro.historico = obrigatorio
				passou = false
			} else {
				this.erro.historico = ''
			}

			if (this._idCliente != 41) {
				if (this.form.classificacao == null || this.form.classificacao == '') {
					this.erro.classificacao = obrigatorio
					passou = false
				} else {
					this.erro.classificacao = ''
				}
			}

			// houve contexto
			if (this.form.houve_contexto == '') {
				this.erro.houve_contexto = obrigatorio
				passou = false
			} else {
				this.erro.houve_contexto = ''

				if (this.form.houve_contexto == '1') {
					if (this.form.contexto_operativo == '') {
						this.erro.contexto_operativo = obrigatorio
						passou = false
					} else {
						this.erro.contexto_operativo = ''
					}
				}
			}

			// orgao
			if (this.form.orgao.length == 0) {
				this.erro.orgao = obrigatorio
				passou = false
			} else {
				this.erro.orgao = ''

				for (var i in this.form.orgao) {
					if (this.form.orgao[i].orgao == '') {
						this.form.orgao[i].erroOrgao = obrigatorio
						passou = false
					} else {
						this.form.orgao[i].erroOrgao = ''
					}
				}
			}
			if (this.form.id_tipo_missao == null) {
				this.erro.id_tipo_missao = obrigatorio
				passou = false
			} else {
				this.erro.id_tipo_missao = null
			}

			if(this.isSigilosa == 1){
				if(this.form.missao_sigilosa == ''){
					this.erro.missao_sigilosa = obrigatorio
					passou = false
				}else{
					this.erro.missao_sigilosa = ''
					if(this.form.usuarios_missao_sigilosa.length == 0 && this.form.missao_sigilosa == 1){
						this.erro.usuarios_missao_sigilosa = obrigatorio
						passou = false
					}else{
						this.erro.usuarios_missao_sigilosa = ''
					}
				}
			}

			return passou
		},

		async carrega(item) {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})

			await this.carregaDadosOap()

			this._httpGet(
				'mg-siga/Despacho_emergencial/get/' + item.id,
				async (retorno) => {
					if (retorno._request && retorno._status) {
						this.form.id = retorno.lista.id
						this.form.aeronave = retorno.lista.aeronave.map((o) => {
							o.voo_instrucao = o.voo_instrucao
							o.erro = ''
							o.erroBase = ''
							o.tripulacao = o.tripulacao.map((trip) => {
								trip.erroTrigrama = ''
								trip.erroFuncao = ''
								trip.load = true
								trip.novo = false
								trip.usuarios = []
								trip.funcao = trip.funcao.toLowerCase()
								return trip
							})

							return o
						})

						for (var j in this.form.aeronave) {
							for (var i in this.form.aeronave[j].tripulacao) {
								this.carregaUsuariosTripulacao(
									j,
									i,
									this.form.aeronave[j].tripulacao[i].funcao,
									false
								)
							}
						}

						// orgaos recebidos
						_.forEach(retorno.lista.orgao, (org) => {
							var orgao_apoiado = []
							var orgao = _.find(this.orgaos, (o) => {
								return o.id == org.id_orgao_apoiado
							})
							orgao_apoiado.orgao = orgao
							orgao_apoiado.erroOrgao = ''
							this.form.orgao.push(orgao_apoiado)
						})

						this.form.inicio_prevencao =
							retorno.lista.prevencao_qualificada == null
								? ''
								: retorno.lista.prevencao_qualificada.inicio_prevencao
						this.form.fim_prevencao =
							retorno.lista.prevencao_qualificada == null
								? ''
								: retorno.lista.prevencao_qualificada.fim_prevencao
						this.form.codigo_prevencao =
							retorno.lista.prevencao_qualificada == null
								? ''
								: retorno.lista.prevencao_qualificada.codigo_prevencao
						this.form.descricao_prevencao =
							retorno.lista.prevencao_qualificada == null
								? ''
								: retorno.lista.prevencao_qualificada.descricao
						this.form.base =
							retorno.lista.base == null ? '' : retorno.lista.base
						this.form.data_inicio = this._SQLDateToDateTime(
							retorno.lista.data_inicio,
							$sessao.getDateFormat() + ' HH:MM'
						)
						this.form.numero_bo = retorno.lista.reds
						this.form.numero_chamada = retorno.lista.chamada
						this.form._tipo = retorno.lista._tipo
						this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
						this.form.data_cadastro = retorno.lista.data_cadastro
						this.form.numero_atividade = retorno.lista.atividade
						this.form.houve_contexto = retorno.lista.houve_contexto
						this.form.historico = retorno.lista.historico
						this.form.numero = retorno.lista.numero
						this.form.id_solicitacao =
							retorno.lista.id_solicitacao == null
								? ''
								: retorno.lista.id_solicitacao
						this.form.solicitacao_descricao =
							retorno.lista.solicitacao_descricao == null
								? ''
								: retorno.lista.solicitacao_descricao
						this.form.solicitacao_codigo =
							retorno.lista.solicitacao_codigo == null
								? ''
								: retorno.lista.solicitacao_codigo

						if (!_.isNil(retorno.lista.relatorio_voo_trecho)) {
							this.form.relatorio_voo_trecho =
								retorno.lista.relatorio_voo_trecho
						} else {
							this.form.relatorio_voo_trecho = []
						}

						this.form.prevencao_inicio = retorno.lista.prevencao_inicio
						this.form.prevencao_fim = retorno.lista.prevencao_inicio
						this.form.id_prevencao_qualificada =
							retorno.lista.id_prevencao_qualificada
						this.form.prevencao_codigo = retorno.lista.prevencao_codigo
						this.form.prevencao_descricao = retorno.lista.prevencao_descricao

						this.form.status = retorno.lista.status
						this.form.id_ordem_missao = retorno.lista.id_ordem_missao
						this.form.tipo = retorno.lista.tipo
						this.form.ordem_descricao = retorno.lista.ordem_descricao
						this.form.ordem_codigo = retorno.lista.ordem_codigo
						this.form.ordem_data_inicio = retorno.lista.ordem_data_inicio
						if (this._idCliente != 41) {
							this.form.classificacao = _.find(this.classificacoes, (c) => {
								return c.id == retorno.lista.id_classificacao
							})
							this.form.subclassificacao = _.find(
								this.subclassificacoes,
								(o) => {
									return o.id == retorno.lista.id_subclassificacao
								}
							)
						}
						// this.form.voo_instrucao = retorno.lista.voo_instrucao

						if (this.form.houve_contexto == 1) {
							this.form.contexto_operativo = _.find(this.contextos, (o) => {
								return o.id == retorno.lista.id_contexto_operativo
							})
						}

						// console.log("form antes carrega dados", this.form)

						// if(this.form.tipo == 'Q'){
						// 	this.carregaPrevencao()
						// }
						this.form.id_tipo_missao = _.find(this.todasMissoes, (o) => {
							return o.id == retorno.lista.id_tipo_missao
						})
						this.form.aeronave[0].trecho = await this.carregarEditarTrecho(
							retorno.lista.aeronave[0].trecho
						)
						this.form.descricao_tipo_missao = retorno.lista.ordem_descricao

						this.form.autorizadoPor = _.find(this.usuarios, (usr) => {
							return usr.id == retorno.lista.autorizado_por
						})

						this.form.missao_sigilosa = retorno.lista.sigilo ? retorno.lista.sigilo : null

						if(retorno.lista.sigilo == '1'){
							retorno.lista.usuarios_sigilo.forEach((us) => {
								_.find(this.usuarios, (usr) => {
									if(usr.id == us.id_usuario){
										this.form.usuarios_missao_sigilosa.push(usr)
									}
								})
							})
						}

						this.getTrechosAeronaves(item.id)

						if (this.visualizar) {
							this.$refs.printVisualizar.carregaDados(this.form)
						}
						window.bus.$emit('load-out')
					}
				}
			)
		},

		clickAddSolicitacao() {
			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			this._httpGet(
				'mg-siga/Solicitacao/get_aprovada/' + $sessao.getId(),
				(retorno) => {
					bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						this.solicitacoes = retorno.lista.map((item) => {
							return item
						})

						this.$refs.modalSolicitacao.modalShow()
					}
				}
			)
		},

		async clickSetaTipo(tipo) {
			// limpa todos os campos referente ao despacho
			await this.carregaDadosOap()
			this.form.id_ordem_missao = ''
			this.form.ordem_codigo = ''
			this.form.ordem_descricao = ''
			this.form.ordem_data_inicio = ''

			this.form.prevencao_inicio = ''
			this.form.prevencao_fim = ''
			this.form.prevencao_codigo = ''
			this.form.prevencao_descricao = ''
			this.form.id_prevencao_qualificada = ''

			this.form.id_solicitacao = ''
			this.form.solicitacao_codigo = ''
			this.form.solicitacao_descricao = ''

			this.form.tipo = tipo

			if (tipo == 'P') {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._httpGet(
					'mg-siga/Ordem_missao/get_execucao/' + $sessao.getId(),
					(retorno) => {
						bus.$emit('load-out')

						if (retorno._request && retorno._status) {
							this.ordens = retorno.lista.map((item) => {
								item.status = item.status == null ? '' : item.status
								item.codigo = item.codigo == null ? '' : item.codigo
								item.descricao_ordem =
									item.descricao_ordem == null ? '' : item.descricao_ordem
								item.codigo_solicitacao =
									item.codigo_solicitacao == null ? '' : item.codigo_solicitacao
								item.descricao_solicitacao =
									item.descricao_solicitacao == null
										? ''
										: item.descricao_solicitacao

								return item
							})
							this.$refs.modalOrdem.modalShow()
						}
					}
				)
			} else if (tipo == 'Q') {
				bus.$emit('load-in', {text: this._traducao('global', 'carregando')})
				this._httpGet('Prevencao_qualificada/get', (retorno) => {
					bus.$emit('load-out')

					if (retorno._request && retorno._status) {
						this.prevencoes = retorno.lista
						this.$refs.modalPrevencao.modalShow()
					}
				})
			}
		},

		async clickSetaOrdem(ordem) {
			if (this.form.id != 0) {
				this.atualiza_ordem = true
			}

			this.form.id_ordem_missao = ordem.id
			this.form.ordem_codigo = ordem.codigo
			this.form.ordem_descricao = ordem.descricao_ordem
			this.form.ordem_data_inicio = ordem.data_inicio
			this.form.data_inicio = ordem.data_inicio
				? this._SQLDateToDateTime(
						ordem.data_inicio,
						$sessao.getDateFormat() + ' HH:MM'
				  )
				: ''

			bus.$emit('load-in', {text: this._traducao('global', 'carregando')})

			await this.carregaDadosOap()
			// CARREGA O DESPACHO PARA A EDICAO
			this._httpGet('mg-siga/Ordem_missao/editar/' + ordem.id, (retorno) => {
				if (retorno._request) {
					bus.$emit('load-out')

					this.$refs.modalOrdem.modalHide()
					//console.log(retorno)
					if (this._idCliente != 41) {
						this.form.classificacao =
							retorno.id_classificacao != null
								? this.getClassificacaoById(retorno.id_classificacao)
								: ''
						this.form.subclassificacao =
							retorno.id_subclassificacao != null
								? this.getSubclassificacaoById(retorno.id_subclassificacao)
								: ''
					}
					this.form.aeronave = []
					for (var i in retorno.aeronave) {
						this.form.aeronave.push({
							id_aeronave: retorno.aeronave[i].id_aeronave,
							voo_instrucao: retorno.aeronave[i].voo_instrucao,
							base: retorno.aeronave[i].base,
							erroBase: '',
							erro: '',
							tripulacao: retorno.aeronave[i].tripulacao.map((item) => {
								item.erroTrigrama = ''
								item.erroFuncao = ''
								item.usuarios = []
								item.load = true
								item.novo = false
								item.funcao = item.funcao.toLowerCase()
								return item
							})
						})
					}

					for (var j in this.form.aeronave) {
						for (var i in this.form.aeronave[j].tripulacao) {
							this.carregaUsuariosTripulacao(
								j,
								i,
								this.form.aeronave[j].tripulacao[i].funcao,
								false
							)
						}
					}

					this.form.houve_contexto = retorno.houve_contexto
					this.form.base = retorno.base
					this.form.numero_chamada = retorno.numero_chamado
					this.form.numero_bo = retorno.numero_bo
					//ORGAO
					// orgaos recebidos
					_.forEach(retorno.orgao, (org) => {
						var orgao_apoiado = []
						var orgao = _.find(this.orgaos, (o) => {
							return o.id == org.id
						})
						orgao_apoiado.orgao = orgao
						orgao_apoiado.erroOrgao = ''
						this.form.orgao.push(orgao_apoiado)
					})

					if (ordem.descricao_solicitacao != '') {
						this.form.historico = ordem.descricao_solicitacao
					} else {
						this.form.historico = retorno.descricao_situacao
					}

					// se tiver adendo
					if (retorno.descricao_solicitacao != '') {
						this.form.historico += ' ADENDO: ' + retorno.descricao_solicitacao
					}

					if (this.form.houve_contexto == '1') {
						for (var i in this.contextos) {
							if (this.contextos[i].id == retorno.id_contexto_operativo) {
								this.form.contexto_operativo = this.contextos[i]
							}
						}
					}
					this.form.id_tipo_missao = _.find(this.todasMissoes, (o) => {
						return o.id == retorno.id_tipo_missao
					})
					let descricao = this.descricoes.find(
						(item) => item.id === retorno.id_descricao_ordem
					)
					this.form.descricao_tipo_missao = descricao
						? descricao.descricao
						: this.form.ordem_descricao
				}
			})
		},

		clickSetaSolicitacao(solicitacao) {
			this.form.id_solicitacao = solicitacao.id
			this.form.solicitacao_codigo = solicitacao.codigo
			this.form.solicitacao_descricao = solicitacao.descricao_solicitacao
			this.$refs.modalSolicitacao.modalHide()
		},

		clickSetaPrevencao(prevencao) {
			this.form.prevencao_inicio = prevencao.inicio_prevencao
			this.form.prevencao_fim = prevencao.fim_prevencao
			this.form.prevencao_codigo = prevencao.codigo_prevencao
			this.form.prevencao_descricao = prevencao.descricao
			this.form.id_prevencao_qualificada = prevencao.id
			this.form.historico = prevencao.descricao

			this.$refs.modalPrevencao.modalHide()
		},

		getSubclassificacaoById(id) {
			for (var i in this.subclassificacoes) {
				if (this.subclassificacoes[i].id == id) {
					return this.subclassificacoes[i]
				}
			}
		},

		getClassificacaoById(id) {
			for (var i in this.classificacoes) {
				if (this.classificacoes[i].id == id) {
					return this.classificacoes[i]
				}
			}
		},

		carregaBase(descricao) {
			for (var i = 0; i < this.bases.length; i++) {
				if (descricao == this.bases[i].descricao) {
					this.form.aeronave[0].base = this.bases[i].id
				}
			}
		},

		clickPrint(tempo) {
			setTimeout(() => {
				this.$refs.printCadastro.carregaDados(this.form)
				this.$nextTick(() => {
					this._print()
				})
			}, tempo)
		},

		carregaTiposMissao() {
			this._httpGet('/Tipo_missao/get', (retorno) => {
				if (retorno._request && retorno._status) {
					this.todasMissoes = retorno.lista
					this.tipos_missao = retorno.lista.filter(
						(item) => item.visualizar == 0
					)
				}
			})
		},

		parametros() {
			this._getParametro(80).then((valor) => (this.labelCritica = valor))
			this._getParametro(6).then((valor) => (this.obrigatoriedade = valor))

			this._getParametro(18).then(
				(valor) => (this.numeroOcorrenciaSamu = valor)
			)
			this._getParametro(19).then((valor) => (this.numeroOcorrencia193 = valor))
			this._getParametro(20).then(
				(valor) => (this.form.ocorrencia193Obrigatoria = valor == 1)
			)
			this._getParametro(28).then((valor) => (this.nomeCampoTipoMissao = valor))
			this._getParametro(29).then(
				(valor) => (this.habilitarCampoDescricao = Number(valor) == 1)
			)
			this._getParametro(30).then((valor) => (this.labelCampoDescricao = valor))
			this._getParametro(31).then(
				(valor) => (this.vincularLista = Number(valor) == 1)
			)
			this._getParametro(32).then(
				(valor) => (this.habilitarEditor = Number(valor) == 1)
			)
			this._getParametro(33).then((valor) => (this.form.execucao = valor))
			this._getParametro(22).then((valor) => (this.exibeRedsSamu = valor))

			this._getParametro(51).then(
				(valor) => (this.encaminharMissaoRealizacao = valor)
			)

			this._getParametro(52).then((valor) => (this.centrodeCusto = valor))
			this._getParametro(83).then((valor) => (this.habilitaPreventiva = valor))
			this._getParametro(169).then(
				(valor) => (this.habilitaCritica = Number(valor) == 1)
			)
			this._getParametro(185).then((valor) => (this.titulo = valor))
			this._getParametro(186).then((valor) => (this.subTitulo = valor))
			this._getParametro(187).then((valor) => {
				this.naoDefinirTipo = valor
				if(valor == 1){
					this.form.tipo = 'E'
				}
			})
			this._getParametro(184).then((valor) => (this.isSigilosa = valor))
		},

		async carregaProgramacao(item) {
			this.form.aeronave = {
				id_aeronave: 0,
				tripulacao: [],
				base: '0',
				voo_instrucao: '0',
				trecho: [trechoFactory.createTrecho()],
				passageiro: [],
				passageiros: 0,
				existe_passageiro: false,
				quantidade_estimada_passageiros: 0,
				erro_passageiros: null
			}

			this._httpGet(
				'mg-siga/Despacho_emergencial/get_despacho_comercial/' + item.id,
				(retorno) => {
					if (retorno._request && retorno._status) {
						this.form.id = retorno.lista.id
						this.form.data_inicio = this._SQLDateToDateTime(
							retorno.lista.data_inicio,
							$sessao.getDateFormat() + ' HH:MM'
						)
						this.carregaDadosAeronave(retorno.lista)

						this.form.orgao = retorno.lista.orgao
						this.form.identificacao_voo = retorno.lista.numero_voo
						this.form.numero_bo = retorno.lista.reds
						this.form.numero_chamada = retorno.lista.chamada
						this.form._tipo = retorno.lista._tipo
						this.form.nome_usuario_inseriu = retorno.lista.nome_usuario_inseriu
						this.form.data_cadastro = retorno.lista.data_cadastro
						this.form.numero_atividade = retorno.lista.atividade
						this.form.houve_contexto = retorno.lista.houve_contexto
						this.form.historico = retorno.lista.historico
						this.form.numero = retorno.lista.numero
						if (!_.isNil(retorno.lista.relatorio_voo_trecho)) {
							this.form.relatorio_voo_trecho =
								retorno.lista.relatorio_voo_trecho
						} else {
							this.form.relatorio_voo_trecho = []
						}

						this.form.status = retorno.lista.status
						this.form.id_ordem_missao = retorno.lista.id_ordem_missao
						this.form.tipo = retorno.lista.tipo
						this.form.ordem_descricao = retorno.lista.ordem_descricao
						this.form.ordem_codigo = retorno.lista.ordem_codigo
						this.form.ordem_data_inicio = retorno.lista.ordem_data_inicio
						if (this._idCliente != 41) {
							this.form.subclassificacao = _.find(
								this.subclassificacoes,
								(o) => {
									return o.id == retorno.lista.id_subclassificacao
								}
							)
						}
						this.form.id_tipo_missao = retorno.lista.tipo_missao.id
						this.form.descricao_tipo_missao =
							retorno.lista.tipo_missao.descricao
						this.form.id_malha_voo = retorno.lista.id_malha_voo
						this.form.descricao_malha_voo = retorno.lista.descricao_malha_voo
						this.form.numero_voo = retorno.lista.numero_voo
						this.form.icao_destino = retorno.lista.icao_destino
						this.form.icao_origem = retorno.lista.icao_origem
						this.form.decolagem_prevista = retorno.lista.decolagem_prevista
						this.form.pouso_previsto = retorno.lista.pouso_previsto
						if (this.despachoComercial) {
							this.exibePouso = this.form.id_malha_voo == null ? false : true
						}

						if (this.visualizar) {
							this.$refs.printVisualizar.carregaDados(this.form)
						}
					}
				}
			)
			window.bus.$emit('load-out')
		},
		async carregaDadosAeronave(dados) {
			this.pilotoOficial = await this.getPilotos(dados.aeronave.id_aeronave)
			this.form.aeronave.id_aeronave = dados.aeronave.id_aeronave
			this.form.aeronave.base = dados.aeronave.base
			const countTrip = dados.aeronave.tripulacao.length
			if (countTrip >= 1) {
				for (let i = 0; i < countTrip; i++) {
					this.form.aeronave.tripulacao.push({
						funcao: dados.aeronave.tripulacao[i].funcao,
						erroNome: null,
						erroFuncao: null,
						load: false,
						usuarios: dados.aeronave.tripulacao[i].nome,
						novo: false,
						usuarios2: this.adicionaPosicao(
							dados.aeronave.tripulacao[i].funcao,
							dados.aeronave.tripulacao[i].nome
						)
					})
				}
			}
			this.form.aeronave.trecho = await this.carregarEditarTrecho(
				dados.aeronave.trecho
			)
			if (dados.aeronave.passageiro.length > 0) {
				this.form.aeronave.existe_passageiro = true
				this.form.aeronave.passageiros = dados.aeronave.passageiro.length
				this.form.aeronave.passageiro = dados.aeronave.passageiro
			}

			if (!dados.id_malha_voo) {
				this.form.aeronave.passageiros = dados.aeronave.passageiro.length
				this.form.aeronave.existe_passageiro =
					dados.aeronave.passageiro.length > 0
				this.form.aeronave.passageiro = dados.aeronave.passageiro.map(
					(passageiro) => {
						passageiro.peso =
							passageiro.peso < 0
								? this.toNumberCasa(passageiro.peso, 2) * -1
								: this.toNumberCasa(passageiro.peso, 2)
						passageiro.peso_bagagem_mao =
							passageiro.peso_bagagem_mao < 0
								? this.toNumberCasa(passageiro.peso_bagagem_mao, 2) * -1
								: this.toNumberCasa(passageiro.peso_bagagem_mao, 2)
						passageiro.peso_bagagem_porao =
							passageiro.peso_bagagem_porao < 0
								? this.toNumberCasa(passageiro.peso_bagagem_porao, 2) * -1
								: this.toNumberCasa(passageiro.peso_bagagem_porao, 2)
						passageiro.passagem =
							passageiro.passagem < 0
								? this.toNumberCasa(passageiro.passagem, 2) * -1
								: this.toNumberCasa(passageiro.passagem, 2)
						passageiro.nomeErro = ''
						passageiro.orgaoErro = ''
						passageiro.cargoErro = ''
						passageiro.cpfErro = ''
						passageiro.trechoErro = ''
						passageiro.telefoneErro = ''
						passageiro.trecho = this.geraTrechoPessoa(
							passageiro,
							this.form.aeronave.trecho
						)
						return passageiro
					}
				)
			}
		},

		toNumberCasa(val, casas) {
			return Number(Number(val).toFixed(casas))
		},

		async getPilotos(idAeronave) {
			return new Promise((resolve) => {
				this._axios(`Usuario/get_tripulacao/${idAeronave}`, 'get', {
					callback(response) {
						if (response._request && response._status) {
							resolve(response.lista)
						}
					}
				})
			})
		},

		adicionaPosicao(funcao, nome) {
			if (funcao == 'piloto em comando' || funcao == 'piloto em instrução') {
				return this.pilotoOficial.filter((t) => t.nome === nome)
			} else {
				const func = this.getTripulantesByFuncao(funcao, this.listaDeFuncoes)
				return func.filter((t) => t.nome === nome)
			}
		},

		getTrechosAeronaves() {
			if (this.form.id) {
				this._axios(
					'mg-siga/Despacho_emergencial/get_trechos_aeronaves/' + this.form.id,
					'get',
					{
						callback: (retorno) => {
							if (retorno._status && retorno._request) {
								this.trechosAeronaves = retorno.lista.map((item) => ({
									...item,
									_decolagem: this._SQLDateToDateTime(
										item.decolagem,
										$sessao.getDateFormat() + ' HH:MM'
									)
								}))
							}
						}
					}
				)
			}
		}
	}
}
</script>

<style>
.table-hover-tr:hover td {
	background: #f0f0f0;
	cursor: pointer;
}

.bk-success {
	background: #dff0d8 !important;
}

.trecho-borda-click-passageiro:hover {
	background: #f9f9f9;
}

.btn-remover-orgao {
	color: red !important;
}

.add:hover {
	background: #fff;
}

.add-modal:hover {
	background: #ddd;
}
</style>